<template>
  <v-text-field
    v-bind="{...defaults, ...$attrs}"
    class="search-field"
    v-on="$listeners"
  />
</template>

<script>
export default {
  name: 'SearchField',
  beforeCreate() {
    this.defaults = {
      label: 'Search',
      filled: true,
      dense: true,
      clearable: true,
      'hide-details': true,
      'prepend-inner-icon': 'mdi-magnify'
    }
  }
}
</script>

<style lang="scss">
.theme--light.v-input.v-text-field.search-field {
  color: var(--v-darkslategray-base);

  label {
    color: var(--v-darkslategray-base);
  }

  .v-icon {
    color: var(--v-darkslategray-base);
  }

  &.v-text-field--filled {
    border-radius: 8px;

    .v-input__control > .v-input__slot:before {
      border-style: none;
    }
  }
}
</style>
